import { ENVIRONMENT } from './ExecutionEnvironmentName';

const STAGING_API_BASE = 'https://stg.sstock.milbon.co.jp/api/v1';
const PRODUCTION_API_BASE = 'https://sstock.milbon.co.jp/api/v1';
const STAGING_MILBON_ID_BASE = 'https://stg.salon.milbon.co.jp';
const PRODUCTION_MILBON_ID_BASE = 'https://salon.milbon.co.jp';

/**
 * @param {import('./ExecutionEnvironmentName').ExecutionEnvironmentName} name
 * @returns {boolean}
 */
export function usesStagingApi(name) {
  return name === ENVIRONMENT.STAGING || name === ENVIRONMENT.DEVELOPMENT;
}

/**
 * @param {import('./ExecutionEnvironmentName').ExecutionEnvironmentName} name
 * @returns {string}
 */
export function getApiBase(name) {
  return usesStagingApi(name) ? STAGING_API_BASE : PRODUCTION_API_BASE;
}

/**
 * @param {import('./ExecutionEnvironmentName').ExecutionEnvironmentName} name
 * @returns {string}
 */
export function getMilbonIdBase(name) {
  return usesStagingApi(name) ? STAGING_MILBON_ID_BASE : PRODUCTION_MILBON_ID_BASE;
}

/**
 * @param {import('./ExecutionEnvironmentName').ExecutionEnvironmentName} name
 * @returns {{ apiBase: string, milbonIdBase: string }}
 */
export function getSettings(name) {
  return {
    apiBase: getApiBase(name),
    milbonIdBase: getMilbonIdBase(name),
  };
}
